import { z } from "zod";

const isoDate = z.iso.date();

/** `z.iso.date()`'s own pattern uses groups structured outputs refuse, so it checks after. */
const date = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .refine((value) => isoDate.safeParse(value).success)
  .meta({ format: "date" });

/** Both ends included; a null end is open. */
const dateRange = z.strictObject({
  from: date.nullable(),
  to: date.nullable(),
});

/**
 * A task list filter: every condition holds at once, and an absent key does not narrow. Keys are
 * `{property}__{operator}`, so the address, the request and a saved view are one shape. Foreday
 * answers in it, so it holds only what structured outputs accept: no `max`, no numeric bounds.
 */
export const taskFilter = z.strictObject({
  status__in: z
    .array(z.enum(["todo", "in_progress", "done"]))
    .min(1)
    .optional(),
  priority__in: z
    .array(z.literal([0, 1, 2, 3]))
    .min(1)
    .optional(),
  /** Null is a task nobody is assigned. */
  assignee_id__in: z.array(z.string().nullable()).min(1).optional(),
  project_id__in: z.array(z.string()).min(1).optional(),
  /** True is a task handed to Foreday, false one that is not. */
  delegated__is: z.boolean().optional(),
  due_on__range: dateRange.optional(),
  /** The day `completed_at` falls on in the company's time zone. */
  completed_on__range: dateRange.optional(),
});

export type TaskFilter = z.infer<typeof taskFilter>;
